import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemIcon } from '@material-ui/core';

const NavigationListItem = (props) => {
    const { text, path, icon } = props;
    const history = useHistory();

    const onClickHandler = () => {
        history.replace(path);
    }

    return (
        <ListItem button key={text} onClick={onClickHandler} >
            <ListItemIcon>
                {icon}
            </ListItemIcon>
            <ListItemText primary={text} />
        </ListItem>
    );
};

export default NavigationListItem;
